import { Checkbox } from "@mui/material";
import { ArrowRight, ChevronLeft, X } from "lucide-react";
import { Button } from "@components/ui/button";
import { useNavigate } from "react-router";
import { SoftwareSystemsData } from "@assets/mocks/filterData";
import SimpleBar from "simplebar-react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@redux/store";
import {
  updateSoftwareSystems,
  toggleIncludeUnknownShopSystem,
  saveFiltersState,
} from "@redux/slices/filter";
import shopify from "../../../../assets/icons/icons8-shopify-48.png";
import shopware from "../../../../assets/icons/icons8-shopware-48.png";
import woocommerce from "../../../../assets/icons/icons8-woocommerce-48.png";
import magento from "../../../../assets/icons/icons8-magento-48.png";
import bigcommerce from "../../../../assets/icons/icons8-bigcommerce-48.png";
import osCommerce from "../../../../assets/icons/icons8-osCommerce-48.png";
import xtcommerce from "../../../../assets/icons/icons8-xtcommerce-48.png";
import virtueMart from "../../../../assets/icons/icons8-virtueMart-48.png";
import prestaShop from "../../../../assets/icons/icons8-prestaShop-48.png";
import plentyMark from "../../../../assets/icons/icons8-plentyMarkets-48.png";
import intershop from "../../../../assets/icons/icons8-intershop-48.png";
import epages from "../../../../assets/icons/icons8-epages-48.png";
import OXIDeShop from "../../../../assets/icons/icons8-OXIDeShop-48.png";
import { FilterAtom } from "@/App";

import {useRecoilState } from "recoil";

interface Props {
  handleClose: () => void;
}

const SoftwareSystemsDetail: React.FC<Props> = ({ handleClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { softwareSystems, includeUnknownShopSystem } = useSelector(
    (state: RootState) => state.filter.softwareAndSystems
  );

  const data = useSelector((state: RootState) => state.filter);

  const currentSoftwareSystems = Array.isArray(softwareSystems)
    ? softwareSystems
    : [];

  const handleSoftwareSystemChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.id;
    const isChecked = event.target.checked;
    const updatedSoftwareSystems = isChecked
      ? [...currentSoftwareSystems, value]
      : currentSoftwareSystems.filter((item) => item !== value);
    console.log(updateSoftwareSystems);
    dispatch(updateSoftwareSystems(updatedSoftwareSystems));
  };

  const handleUnknownShopSystemChange = () => {
    dispatch(toggleIncludeUnknownShopSystem());
  };


  
  const [filter, setFilter] = useRecoilState(FilterAtom);
  const handleClick = (id: string) => {
    console.log("now clicked is " + id);
    // setClickedIds((prevStrings) => [...prevStrings, id]);
    setFilter((prevFilters: string[]) => [...prevFilters, id]); // Append to the atom
    console.log("I am here now");
  };
  

  return (
    <div className="flex flex-col justify-between h-full p-8">
      <div>
        <div className="flex justify-between items-center mb-5">
          <h4 className="text-xl font-bold flex items-center -ms-2">
            <ChevronLeft
              size={22}
              className="me-3 cursor-pointer"
              onClick={() => navigate(-1)}
            />
            Software Systems
          </h4>
          <X onClick={handleClose} className="cursor-pointer" />
        </div>
        <div className="flex gap-4">
          <div className="bg-white rounded-lg w-2/3 px-6 py-4">
            <h4 className="text-lg font-bold flex items-center mb-4">
              Select Software Systems
            </h4>
            <SimpleBar style={{ maxHeight: 310 }}>
              <div className="flex items-end me-4 text-sm font-medium cursor-pointer text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1">
                <Checkbox
                  id={"Shopify"}
                  checked={currentSoftwareSystems.includes("Shopify")}
                  onChange={handleSoftwareSystemChange}
                  sx={{ color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    },padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={shopify} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">Shopify</h6>
                </div>
              </div>
              {/* <div className="flex items-end me-4 text-sm font-medium cursor-pointer pt-3 text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1">
                <Checkbox
                  id={"Shopify"}
                  checked={currentSoftwareSystems.includes("Shopify")}
                  onChange={handleSoftwareSystemChange}
                  sx={{ padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={shopify} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">Shopify</h6>
                </div>
              </div>{" "} */}
              <div className="flex items-end me-4 text-sm font-medium cursor-pointer pt-3 text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1">
                <Checkbox
                  id={"WooCommerce"}
                  checked={currentSoftwareSystems.includes("WooCommerce")}
                  onChange={handleSoftwareSystemChange}
                  sx={{ color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    },padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={woocommerce} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">WooCommerce</h6>
                </div>
              </div>{" "}
              <div className="flex items-end me-4 text-sm font-medium cursor-pointer pt-3 text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1">
                <Checkbox
                  id={"BigCommerce"}
                  checked={currentSoftwareSystems.includes("BigCommerce")}
                  onChange={handleSoftwareSystemChange}
                  sx={{ color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    },padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={bigcommerce} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">BigCommerce</h6>
                </div>
              </div>{" "}
              <div className="flex items-end me-4 text-sm font-medium cursor-pointer pt-3 text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1">
                <Checkbox
                  id={"PrestaShop"}
                  checked={currentSoftwareSystems.includes("PrestaShop")}
                  onChange={handleSoftwareSystemChange}
                  sx={{color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    }, padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={prestaShop} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">PrestaShop</h6>
                </div>
              </div>{" "}
              <div className="flex items-end me-4 text-sm font-medium cursor-pointer pt-3 text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1">
                <Checkbox
                  id={"Magento"}
                  checked={currentSoftwareSystems.includes("Magento")}
                  onChange={handleSoftwareSystemChange}
                  sx={{ color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    },padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={magento} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">Magento</h6>
                </div>
              </div>{" "}
              <div className="flex items-end me-4 text-sm font-medium cursor-pointer pt-3 text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1">
                <Checkbox
                  id={"xtCommerce"}
                  checked={currentSoftwareSystems.includes("xtCommerce")}
                  onChange={handleSoftwareSystemChange}
                  sx={{ color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    },padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={xtcommerce} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">xtCommerce</h6>
                </div>
              </div>{" "}
              <div className="flex items-end me-4 text-sm font-medium cursor-pointer pt-3 text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1">
                <Checkbox
                  id={"epages"}
                  checked={currentSoftwareSystems.includes("epages")}
                  onChange={handleSoftwareSystemChange}
                  sx={{color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    }, padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={epages} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">epages</h6>
                </div>
              </div>{" "}
              <div className="flex items-end me-4 text-sm font-medium cursor-pointer pt-3 text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1">
                <Checkbox
                  id={"VirtueMart"}
                  checked={currentSoftwareSystems.includes("VirtueMart")}
                  onChange={handleSoftwareSystemChange}
                  sx={{color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    }, padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={virtueMart} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">Virtue Mart</h6>
                </div>
              </div>{" "}
              <div className="flex items-end me-4 text-sm font-medium cursor-pointer pt-3 text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1">
                <Checkbox
                  id={"OXIDeShop"}
                  checked={currentSoftwareSystems.includes("OXIDeShop")}
                  onChange={handleSoftwareSystemChange}
                  sx={{ color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    },padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={OXIDeShop} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">OXID eShop</h6>
                </div>
              </div>{" "}
              <div className="flex items-end me-4 text-sm font-medium cursor-pointer pt-3 text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1">
                <Checkbox
                  id={"Shopware"}
                  checked={currentSoftwareSystems.includes("Shopware")}
                  onChange={handleSoftwareSystemChange}
                  sx={{ color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    },padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={shopware} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">Shopware</h6>
                </div>
              </div>{" "}
              <div className="flex items-end me-4 text-sm font-medium cursor-pointer pt-3 text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1">
                <Checkbox
                  id={"Plentymarkets"}
                  checked={currentSoftwareSystems.includes("Plentymarkets")}
                  onChange={handleSoftwareSystemChange}
                  sx={{ color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    },padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={plentyMark} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">Plentymarkets</h6>
                </div>
              </div>{" "}
              <div className="flex items-end me-4 text-sm font-medium cursor-pointer pt-3 text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1">
                <Checkbox
                  id={"Intershop"}
                  checked={currentSoftwareSystems.includes("Intershop")}
                  onChange={handleSoftwareSystemChange}
                  sx={{color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    }, padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={intershop} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">Intershop</h6>
                </div>
              </div>{" "}
              <div className="flex items-end me-4 text-sm font-medium cursor-pointer pt-3 text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1">
                <Checkbox
                  id={"SalesforceCommerceCloud"}
                  checked={currentSoftwareSystems.includes(
                    "SalesforceCommerceCloud"
                  )}
                  onChange={handleSoftwareSystemChange}
                  sx={{color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    }, padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={shopify} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">Salesforce Commerce Cloud</h6>
                </div>
              </div>{" "}
              <div className="flex items-end me-4 text-sm font-medium cursor-pointer pt-3 text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1">
                <Checkbox
                  id={"Smartstore"}
                  checked={currentSoftwareSystems.includes("Smartstore")}
                  onChange={handleSoftwareSystemChange}
                  sx={{ color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    },padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={shopify} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">Smartstore</h6>
                </div>
              </div>
              <div className="flex items-end me-4 text-sm font-medium cursor-pointer pt-3 text-[#71717A]">
                <Checkbox
                  id={"osCommerce"}
                  checked={currentSoftwareSystems.includes("osCommerce")}
                  onChange={handleSoftwareSystemChange}
                  sx={{color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    }, padding: 0 }}
                />
                <div className="flex items-center ms-3">
                  <img src={osCommerce} alt="" className="h-5 me-2" />
                  <h6 className="ms-1">osCommerce</h6>
                </div>
              </div>
            </SimpleBar>
          </div>
          <div className="flex flex-col justify-between w-1/3">
            <div className="bg-white rounded-lg px-6 py-4">
              <h4 className="text-lg font-bold flex items-center mb-4">
                Include
              </h4>
              <div
                className={`flex items-center text-sm font-medium cursor-pointer text-[#71717A]`}
              >
                <Checkbox
                  sx={{color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    }, padding: 0 }}
                  checked={includeUnknownShopSystem}
                  onChange={handleUnknownShopSystemChange}
                />
                <h6 className="ms-1">Unknown Shop System</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-end">
        <Button 
        onClick={() => {
          handleClick("Software Systems"); // Replace someValue with the actual value you want to pass
          navigate(-1); // Navigate back
        }}  className="bg-[#1CB5AF]">Save</Button>
      </div>
    </div>
  );
};

export default SoftwareSystemsDetail;
